export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }).format(amount);
};

export const formatDate = (date) => {
  return new Intl.DateTimeFormat('en-IN', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(new Date(date));
};

export const formatDateTime = (date) => {
  return new Intl.DateTimeFormat('en-IN', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(date));
};

export const getStockStatusColor = (status) => {
  const colors = {
    'In Stock': 'bg-green-100 text-green-800 border-green-200',
    'Available on Order': 'bg-blue-100 text-blue-800 border-blue-200',
    'Limited Stock': 'bg-orange-100 text-orange-800 border-orange-200',
    'Discontinued': 'bg-gray-100 text-gray-800 border-gray-200',
  };
  return colors[status] || 'bg-gray-100 text-gray-800 border-gray-200';
};

export const convertToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export const getCategoryIcon = (category) => {
  const icons = {
    'Apparel': '👔',
    'Electronics': '💻',
    'Drinkware': '☕',
    'Stationery': '✏️',
    'Bags & Travel': '🎒',
    'Food & Gourmet': '🍫',
    'Wellness': '🧘',
    'Desk Accessories': '📎',
    'Festive & Seasonal': '🎉',
    'Luxury': '💎',
    'Eco-Friendly': '🌱',
    'Custom/Other': '🎁',
  };
  return icons[category] || '🎁';
};
